import { createRoot } from 'react-dom/client';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';
import CreateGiftcard from './create-gift-card/CreateGiftcard';
import { UserTextCustomizations } from '@repo/types';

class BilberryGiftcardButton extends BilberryCustomElement {
    protected renderWidget(): void {
        const size = this.getAttribute('size')?.toLowerCase();
        const xsSize = this.getAttribute('xs-size')?.toLowerCase();
        const buttonTextCustomizationKey = this.getAttribute(
            'button-text-customization-key',
        ) as keyof UserTextCustomizations;

        let sizeOrDefault: 's' | 'm' | 'l' = 's';
        let xsSizeOrDefault: 's' | 'm' | 'l' = 's';

        if (size === 's' || size === 'm' || size === 'l') {
            sizeOrDefault = size;
        }

        if (xsSize === 's' || xsSize === 'm' || xsSize === 'l') {
            xsSizeOrDefault = xsSize;
        }

        createRoot(this._mountPoint).render(
            <WidgetWrapper
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
            >
                <CreateGiftcard
                    size={sizeOrDefault}
                    xsSize={xsSizeOrDefault}
                    buttonTextCustomizationKey={buttonTextCustomizationKey ?? undefined}
                />
            </WidgetWrapper>,
        );
    }
}

export default function defineCustomElement() {
    customElements.define('bilberry-gift-card-button', BilberryGiftcardButton);
}
